import { useMutation } from "@tanstack/react-query";
import { calculateUsersCount } from "../api.ts";
import type { CreateCampaignFormData } from "../../types.ts";

// Mutation hook for calculating users count based on filter criteria
export const useCalculateUsersCountMutation = () => {
  return useMutation<number, Error, CreateCampaignFormData>({
    mutationFn: async (filterCriteria: CreateCampaignFormData) => {
      const response = await calculateUsersCount(filterCriteria);
      return response.data;
    },
  });
};
